import {empty} from "../common";
import {alertMessage, closeModals, notice} from "../messages";
import {updateCartInfo} from "./updateCartInfo";

export const addToCart = evt =>{
    let self = evt.currentTarget;
    evt.preventDefault();
    evt.stopPropagation();
    let form = self.closest('.rbm_js_product_item');
    let countComponent = form.querySelector('.count_product_item');

    let cnt = 1;
    if(countComponent){
        cnt = countComponent.value;
    }

    let productId = self.dataset.id;

    if (empty(cnt)) {
        cnt = 1;
    }

    let output = {
        action: 'addtocart',
        product_id: productId,
        data_json: {},
        count: cnt,
    };
    (async () => {
        try {
            self.classList.add('preloader');
            const rawResponse = await fetch(`/includes/modules/cart/cart_functions.php`, {
                mode: 'cors',
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: 'data=' + JSON.stringify(output)
            });
            const content = await rawResponse.json();

            closeModals();
            if (content.error === 'ok') {
                if (document.location.pathname === '/cart.html') {
                    document.location.reload(true);
                    return;
                }
                self.classList.add('active');
                updateCartInfo(content);
                notice('Товар добавлен в корзину.');
            } else {
                alertMessage('Ошибка', "Обратитесь к администратору.");
            }
        } catch (e) {
            alertMessage('Попробуйте ещё раз.', e.message || '<h3>Не удалось выполнить действие</h3>')
        } finally {
            self.classList.remove('preloader');
        }
    })();
}
